import React from 'react';

import { PERMISSION } from 'pages/LeadStatus/utils/constants';

const LeadStatusPage = React.lazy(() => import('pages/LeadStatus/LeadStatusPage'));
const LeadStatusAddPage = React.lazy(() => import('pages/LeadStatus/LeadStatusAddPage'));

const leadStatusRoute = [
  {
    path: '/lead-status',
    exact: true,
    name: 'Danh sách trạng thái lead',
    function: PERMISSION.VIEW,
    component: LeadStatusPage,
  },
  {
    path: '/lead-status/add',
    exact: true,
    name: 'Thêm mới trạng thái lead',
    function: PERMISSION.ADD,
    component: LeadStatusAddPage,
  },
  {
    path: '/lead-status/edit/:status_data_leads_id',
    exact: true,
    name: 'Chỉnh sửa trạng thái lead',
    function: PERMISSION.EDIT,
    component: LeadStatusAddPage,
  },
  {
    path: '/lead-status/detail/:status_data_leads_id',
    exact: true,
    name: 'Chi tiết trạng thái lead',
    function: PERMISSION.DETAIL,
    component: LeadStatusAddPage,
  },
];

export default leadStatusRoute;
